// 自定义指令
import Vue from 'vue';
// import clickoutside from './clickoutside';

// 聚焦元素
Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时
  inserted(el) {
    // 在页面加载后再聚焦元素
    setTimeout(() => {
      el.focus();
    });
  },
});

// 点击外部操作
// 这个需要在组件中进行注册才起作用，全局注册不知道为啥不起作用
// Vue.directive('clickoutside', { clickoutside });
